import { render, staticRenderFns } from "./AssignToCuratorListener.vue?vue&type=template&id=1239741d"
import script from "./AssignToCuratorListener.vue?vue&type=script&lang=js"
export * from "./AssignToCuratorListener.vue?vue&type=script&lang=js"
import style0 from "./AssignToCuratorListener.vue?vue&type=style&index=0&id=1239741d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports